import React from 'react';
import { Navigate } from 'react-router-dom';

export const PrivateRoute = (props) => {
    if (!props.user.loggedIn) {
        // not logged in so redirect to login page with the return url
        return <Navigate to='/login' />
    }

    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    // return children;
    return props.children;
}

export default PrivateRoute;
